export enum RecurrenceMode {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  WEEKDAYS = 'weekdays',
  CUSTOM = 'custom',
}

export enum RecurrenceWeekdayNumber {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export interface RecurrenceWeekdayData {
  id: RecurrenceWeekdayNumber;
  label: string;
  name: string;
}

/** A recurrence rule for a record */
export interface Recurrence {
  mode: RecurrenceMode;
  freq: number;
  interval?: number;
  byweekday?: number[];
  until?: Date;
  count?: number;
}

/** Type for indicating that a record is recurrable */
export interface Recurrable<T = unknown> {
  id: string;
  /** The start date of the record */
  start: Date;

  /** Calendar Item recurrence rule. This is based on the ical specification */
  recurrence?: Recurrence;

  /** Dates of event instances that have been deleted and should not be generated */
  recurrenceExcludeDates: { [key: string]: true };

  /** Dates that recurrences can be generated until */
  recurrenceUntil?: Date;

  /** Recurrence instances */
  recurrences?: T[];

  /** Indicates if the calendar item is a recurrence instance */
  isRecurrence?: boolean;

  /**
   * Each calendar item recurrence instance can have override data (such as for checklists)
   * This data can be loaded into each instance upon generation
   */
  recurrenceInstanceData?: { [key: string]: Partial<T> };

  /** The original calendar item. Only set on calendar item recurrences. */
  origin?: Recurrable<T>;

  origin_id?: string;
}
